var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHuobi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1521 4.30619C6.1521 2.29749 5.17345 0.567564 4.4281 0.00607848C4.4281 0.00607848 4.37076 -0.0255545 4.3767 0.0555051C4.31541 3.93648 2.33241 4.98828 1.24305 6.40385C-1.27177 9.67392 1.06512 13.2583 3.44945 13.9206C4.77804 14.2923 3.14103 13.2643 2.92949 11.0954C2.67049 8.47779 6.1521 6.47701 6.1521 4.30619Z",
    fill: "#1B2143"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29471 5.6288C7.27889 5.61891 7.25715 5.61101 7.24331 5.63671C7.20179 6.12504 6.70357 7.16893 6.07091 8.12978C3.92579 11.384 5.14762 12.9538 5.83564 13.798C6.235 14.2864 5.83564 13.798 6.83208 13.2978C8.06379 12.5505 8.86252 11.2575 8.98114 9.82215C9.17687 7.50899 7.78898 6.05189 7.29471 5.6288Z",
    fill: "#2CA6E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuobi);
export default __webpack_public_path__ + "static/media/huobi.0c854e1afdad422c9b455605a3be7dc2.svg";
export { ForwardRef as ReactComponent };